import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Button from 'react-bootstrap/Button';

import {TEXT} from '../../utilities/strings';

/**
 * Component for handling data, image, or vector exports and drawing the controls for each
 *
 * @example
 * return (
 *  <ControlExports
 *    onExportData={this.props.onExportData}
 *    onExportImage={this.props.onExportImage}
 *    onExportVector={this.props.onExportVector}
 *  />;
 * )
 */
export default class ControlExports extends PureComponent {

  static propTypes = {
    showImageExports: PropTypes.bool,
    onExportData: PropTypes.func,
    onExportImage: PropTypes.func,
    onExportVector: PropTypes.func
  };

  static defaultProps = {
    showImageExports: true
  }

  handleExportData = () => {
    if (this.props.onExportData) {
      this.props.onExportData()
    }
  };

  handleExportImage = () => {
    if (this.props.onExportImage) {
      this.props.onExportImage()
    }
  };

  handleExportVector = () => {
    if (this.props.onExportVector) {
      this.props.onExportVector()
    }
  };

  render() {

    return (
      <div>

        <Button
          variant="link"
          type="button"
          size="sm"
          onClick={this.handleExportData}
          children={TEXT.export_data}
        />

        {this.props.showImageExports && (
          <div className="float-right d-inline-block">

            <Button
              variant="link"
              type="submit"
              size="sm"
              className="ie-hidden"
              onClick={this.handleExportImage}
              children={TEXT.export_image}
            />

            <div className="vert-divider d-inline-block ie-hidden"/>

            <Button
              variant="link"
              type="submit"
              size="sm"
              onClick={this.handleExportVector}
              children={TEXT.export_vector}
            />

          </div>
        )}

      </div>
    );
  }
}
